import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "toolbar",
  id: "kt_toolbar_images"
}
const _hoisted_2 = {
  id: "kt_page_title",
  "data-kt-swapper": "false",
  "data-kt-swapper-mode": "prepend",
  "data-kt-swapper-parent": "{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}",
  class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0 d-md-none d-sm-none d-lg-block",
  style: {"padding":"15px 0 0 0 0 !important"}
}
const _hoisted_3 = { class: "d-flex align-items-center text-dark fw-bolder my-1 fs-3" }
const _hoisted_4 = {
  key: 0,
  class: "h-20px border-gray-200 border-start mx-4"
}
const _hoisted_5 = { class: "d-flex align-items-center py-1" }
const _hoisted_6 = { class: "me-4" }
const _hoisted_7 = {
  href: "#",
  class: "btn btn-sm btn-flex btn-light btn-active-primary fw-bolder rounded-pill",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_8 = { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_FilterImages = _resolveComponent("FilterImages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "kt_toolbar_container",
      class: _normalizeClass([{
        'container-fluid': _ctx.toolbarWidthFluid,
        'container-xxl': !_ctx.toolbarWidthFluid,
      }, "d-flex flex-stack"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("images")), 1),
        (_ctx.breadcrumbs)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg, { src: "media/icons/gen031.svg" })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.dateFilter == null ? _ctx.$t("filter") : "") + _toDisplayString(_ctx.dateFilter != null
                ? new Date(_ctx.dateFilter["startDate"])
                    .toLocaleDateString()
                    .substring(0, 10) +
                  " - " +
                  new Date(_ctx.dateFilter["endDate"])
                    .toLocaleDateString()
                    .substring(0, 10)
                : ""), 1)
          ]),
          _createVNode(_component_FilterImages, {
            onApplyfilter: _ctx.propageFilters,
            ref: "theFilter"
          }, null, 8, ["onApplyfilter"])
        ])
      ])
    ], 2)
  ]))
}